var WDN = WDN || {};

/*
  Contains code for:
  - Float add
  - Sticky gallery
*/

if (typeof WDN.Productpage_floatadd === "undefined") {
  WDN.Productpage_floatadd = (function () {
    var hasVariantPricing = ProductPage && ProductPage.prices && ProductPage.prices.priceMoney && ProductPage.prices.priceMoney.length > 0;

    // Nodes
    var itemToFindInViewport = document.querySelector(".shopify-product-form button");
    var itemToStick = document.querySelector(".product__floatbuy");

    var image_gallery_container = document.querySelector("[data-product-gallery]");
    var image_gallery = document.querySelector("[data-product-gallery] .product-gallery");

    var _getCurrentScrollOffset = function () {
      return window.scrollY + window.innerHeight;
    };

    var _getItemOffset = function (item) {
      if (!item) return false;

      var pos = item.getBoundingClientRect();

      return {
        start: pos.top + window.scrollY,
        end: pos.bottom + window.scrollY + window.innerHeight,
      };
    };

    var image_gallery_offset = _getItemOffset(image_gallery);

    var _isInViewport = function () {
      var _currentScrollOffset = _getCurrentScrollOffset();
      var _targetItemPagePosition = _getItemOffset(itemToFindInViewport);

      return {
        current: _currentScrollOffset,
        target: _targetItemPagePosition,
      };
    };

    var _toggleStickyAddToCart = function () {
      var chatTargElem = document.querySelector("jdiv");

      var state = _isInViewport();

      var scrolledPast = false;

      if (state.current > state.target.end) {
        scrolledPast = true;
      }

      if (scrolledPast) {
        itemToStick.setAttribute("data-fix-top", "");
        document.body.setAttribute("data-chat-hidden", "");
      } else {
        itemToStick.removeAttribute("data-fix-top");
        document.body.removeAttribute("data-chat-hidden");
      }

      var scrollFromTop = state.current - window.innerHeight;

      if (!image_gallery_container) return;

      // Stick image gallery
      if (window.innerWidth < 1025) {
        var headerHeight = parseFloat(WDN.CSSVariable.get("--header-height")) + parseFloat(WDN.CSSVariable.get("--announcement-height"));
        var countdownLarge = document.querySelector('.countdownLarge');
        if (countdownLarge && !countdownLarge.classList.contains('absoluteCountdown')) headerHeight += countdownLarge.getBoundingClientRect().height;
        
        if (scrollFromTop > headerHeight && state.current < image_gallery_offset.end) {
          image_gallery_container.setAttribute("data-fixed-gallery", "");
        } else {
          image_gallery_container.removeAttribute("data-fixed-gallery");
        }
      }
    };

    var _debouncedCheckIfInViewport = _toggleStickyAddToCart;

    var _listenForScroll = function () {
      window.addEventListener("scroll", _debouncedCheckIfInViewport);
    };

    var _updateComparePriceElements = function () {
      var priceTargets = document.querySelectorAll(".product__floatbuy [data-variant-compare-price]");

      if (!ProductPage.prices.onSale) {
        priceTargets.forEach(function (element) {
          element.innerText = "";
        });
        return;
      }

      priceTargets.forEach(function (element) {
        element.innerText = ProductPage.prices.priceCompareMoney;
      });
    };

    var _updatePriceElements = function () {
      var priceTargets = document.querySelectorAll(".product__floatbuy [data-variant-price]");

      priceTargets.forEach(function (element) {
        element.innerText = ProductPage.prices.priceMoney;
      });
    };

    var _setActiveVariantPrice = function () {
      if (hasVariantPricing) {
        _updatePriceElements();
        _updateComparePriceElements();
      }
    };

    var onVariantChange = function () {
      if (hasVariantPricing) {
        _updatePriceElements();
        _updateComparePriceElements();
      }
    };

    var _listenForVariantChange = function () {
      if (hasVariantPricing) {
        _setActiveVariantPrice();

        var variant_items = document.querySelectorAll('input[name="variant_selection"]');
        variant_items.forEach(function (element) {
          element.addEventListener("click", onVariantChange);
        });
      }
    };

    var _mount = function () {
      _listenForScroll();
      itemToStick.removeAttribute("data-not-mounted");
      _toggleStickyAddToCart();
      _listenForVariantChange();
    };

    if (itemToFindInViewport && itemToStick) {
      _mount();
    }

    return {};
  })();
}

// Product gallery
if (typeof WDN.ProductGallery === "undefined") {
  WDN.ProductGallery = (function () {
    window.addEventListener("load", function () {
      WDN.Slider.create(
        {
          id: "product_gallery",
          config: {
            slides: { origin: "auto", perView: 1, spacing: 0 },
          },
        },
        true
      );
    });

    /* Change to loading="eager" on Gallery media, after first interaction by the user. */
    var gallery = document.querySelector("[data-product-gallery]");
    var galleryButtons = gallery.querySelectorAll("slider-control");
    var galleryMedias = gallery.querySelectorAll("img, video");

    if (!gallery || galleryMedias.length === 0) return;
    var eagerImages = () => {
      galleryMedias.forEach((media) => {
        if (!media.hasAttribute("loading")) return;
        if (media.getAttribute("loading") !== "lazy") return;
        media.setAttribute("loading", "eager");
      });
    };

    gallery.addEventListener("mouseover", eagerImages);
    gallery.addEventListener("touchstart", eagerImages);
    gallery.addEventListener("touchmove", eagerImages);
    if (galleryButtons.length > 0) {
      galleryButtons.forEach((btn) => btn.addEventListener("click", eagerImages));
    }

    document.querySelector("#product_gallery").addEventListener("slider:created", () => {
      var paginationButtons = gallery.querySelectorAll("slider-pagination");
      if (paginationButtons.length > 0) paginationButtons.forEach((btn) => btn.addEventListener("click", eagerImages));
    });
    return {};
  })();
}
